@if (rows.length && dataFields.length) {
  <ng-container *ngTemplateOutlet="showRows"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="noRowsFound"></ng-container>
}

<ng-template #showRows>
  @if (!isEosInventoryRow(rows[0])) {
    <text-button
      class="display--block margin-left--1x margin-bottom--1x"
      icon="download"
      (click)="downloadExcel()"
      [disabled]="disabled"
    >
      Exportera rader till Excel
    </text-button>
  }
  @if(editFields) {
    <ng-container *ngTemplateOutlet="edit"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="default"></ng-container>
  }

  <ng-template #default>
    <div class="padding-left-right--1x grid-columns--6 button-colum-right text--small align-items--center text--thin margin-bottom--2x">
      @for (column of promotedProperties; track $index) {
        <span class="margin-left-right--2x">
          {{ column.name }}
        </span>
      }
      <button
        class="margin-left-right--2x status-badge badge--focus primary margin--none"
        type="button"
        title="Ändra celler"
        (click)="editFields = !editFields"
      >
        <span class="icon-edit"></span>
      </button>
    </div>
  </ng-template>

  <ng-template #edit>
    <div class="grid-columns--6 button-colum-right padding-left-right--1x align-items--center">
      @for (data of promotedProperties; track data.value) {
        <span
          class="margin-left-right--2x woo-dropdown-small"
        >
          <woo-dropdown
            [items]="dataFields"
            [(ngModel)]="promotedProperties[$index]"
          ></woo-dropdown>
        </span>
      }
      <button
        class="margin-left-right--2x status-badge badge--focus primary margin-top-bottom--none"
        type="button"
        (click)="editFields = !editFields"
      >
        <span class="icon-close-x"></span>
      </button>
    </div>
  </ng-template>
  @for (row of rows; track $index) {
    <campaign-row-card
      [row]="row"
      [promotedProperties]="promotedProperties"
      [dataFields]="dataFields"
    ></campaign-row-card>
  }
</ng-template>

<ng-template #noRowsFound>
  <h3>Inga rader hittades</h3>
</ng-template>
